// extracted by mini-css-extract-plugin
module.exports = {"input":"newStyle_input__3q6n7","modal":"newStyle_modal__2TQdh"};